import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GroupRecordTypeLookupComponent } from './group-record-type-lookup.component';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [GroupRecordTypeLookupComponent],
  exports: [GroupRecordTypeLookupComponent]
})
export class GroupRecordTypeLookupModule { }
